export default __webpack_public_path__ + "static/media/logo_lumen_dark.780933d6.png";